import getJSONValue from 'nucleus-widgets/utils/fields/getJSONValue';
import { find } from 'lodash';

export function getRegistrationJsonPath(registrationPathId, ...subPaths) {
  return ['registrationSettings', 'registrationPaths', registrationPathId, ...subPaths];
}

export function getContactFieldJsonPath(registrationPathId, registrationFieldPageType, fieldId, ...subPaths) {
  return getRegistrationJsonPath(
    registrationPathId, 'registrationPageFields', String(registrationFieldPageType),
    'registrationFields', fieldId, ...subPaths);
}

export function getContactSubFieldJsonPath(registrationPathId, registrationFieldPageType, fieldId, ...subPaths) {
  return getContactFieldJsonPath(
    registrationPathId, registrationFieldPageType, fieldId, 'subFieldDisplayNames', ...subPaths);
}

export function getContactField(appData, registrationPathId, registrationFieldPageType, fieldId) {
  return getJSONValue(appData, getContactFieldJsonPath(registrationPathId, registrationFieldPageType, fieldId));
}

export function getProductQuestion(appData, questionId) {
  return getProductQuestions(appData)[questionId];
}

export function getTravelQuestion(appData, questionId) {
  return getTravelQuestions(appData)[questionId];
}

export function getProductQuestions(appData) {
  return appData.registrationSettings.productQuestions;
}

export function getTravelQuestions(appData) {
  return appData.registrationSettings.travelQuestions || {};
}

export function getEventQuestionJsonPathPrefix(appData, questionId) {
  const isProductQuestion = getProductQuestion(appData, questionId);
  if (isProductQuestion) {
    return `registrationSettings.productQuestions.${questionId}`;
  }
  const isTravelQuestion = getTravelQuestion(appData, questionId);
  if (isTravelQuestion) {
    return `registrationSettings.travelQuestions.${questionId}`;
  }
  return `registrationSettings.registrationQuestions.${questionId}`;
}

export function getQuestionRegPathAssociationsJsonPath(appData, questionId) {
  return `${getEventQuestionJsonPathPrefix(appData, questionId)}.registrationPathQuestionAssociations`;
}

export function getEventQuestionJsonPath(appData, questionId) {
  return `${getEventQuestionJsonPathPrefix(appData, questionId)}.question`;
}

export function getQuestionAssociationsJsonPath(appData, questionId) {
  const isProductQuestion = getProductQuestion(appData, questionId);
  if (isProductQuestion) {
    return `registrationSettings.productQuestions.${questionId}.productQuestionAssociations`;
  }
  const isTravelQuestion = getTravelQuestion(appData, questionId);
  if (isTravelQuestion) {
    return `registrationSettings.travelQuestions.${questionId}.travelQuestionAssociations`;
  }
  return `registrationSettings.registrationQuestions.${questionId}.registrationPathQuestionAssociations`;
}

export function getSubQuestionParentQuestionIdJsonPath(appData, questionId) {
  return `${getEventQuestionJsonPathPrefix(appData, questionId)}.parentQuestionId`;
}

export function getSubQuestionLogicChoicesJsonPath(appData, questionId) {
  return `${getEventQuestionJsonPathPrefix(appData, questionId)}.subQuestionLogicChoices`;
}

export function getRegistrationPath(appData, registrationPathId) {
  return appData.registrationSettings.registrationPaths[registrationPathId];
}

export function getRegistrationTypeSettings(appData, registrationPathId) {
  return getRegistrationPath(appData, registrationPathId).registrationTypeSettings;
}

export function getDefaultRegistrationPath(appData) {
  return find(appData.registrationSettings.registrationPaths, regPath => regPath.isDefault);
}

export function getEventQuestions(appData) {
  const { registrationSettings: { registrationQuestions, productQuestions, travelQuestions = {} } } = appData;
  return [...Object.values(registrationQuestions), ...Object.values(productQuestions),
    ...Object.values(travelQuestions)];
}

export function getEventQuestionById(appData, questionId) {
  const eventQuestions = getEventQuestions(appData);
  return (eventQuestions || []).find(eventQuestion => eventQuestion.question.id === questionId);
}

export function getSubQuestionsByParentQuestionId(appData, parentQuestionId) {
  const eventQuestions = getEventQuestions(appData);
  return (eventQuestions || []).filter(question => question.parentQuestionId === parentQuestionId);
}

export function getReportingQuestionTagAssociationJsonPath(appData, questionId) {
  return `${getEventQuestionJsonPath(appData, questionId)}.questionTag`;
}
